<dashboard-dialog-frame [header]="'Dashboard filters'" [dialogRef]='dialogRef' [actions]="actions">

	<div class='dashboard-filters-dialog-content'>
		Filters...
	</div>

</dashboard-dialog-frame>